import { ROUTES } from './paths';

export function getRouteLabel(pathname: string): string {
  const path = normalizePath(pathname);

  const exact: Readonly<Record<string, string>> = {
    '/': 'Динамика',
    [ROUTES.analytics.wordstat]: 'Отчёты Wordstat',
    [ROUTES.tasks.wordstat]: 'Задания Wordstat',
    [ROUTES.tasks.wordstatNew]: 'Новое задание Wordstat',
    [ROUTES.analytics.dynamics]: 'Динамика',
    [ROUTES.analytics.serpset]: 'Выдача',
    [ROUTES.login]: 'Вход',
    [ROUTES.tasks.overview]: 'Центр заданий',
    [ROUTES.tasks.targets]: 'Цели',
    [ROUTES.tasks.baskets]: 'Корзины запросов',
    [ROUTES.tasks.connections]: 'Подключения Yandex Search API',
    [ROUTES.tasks.oneTimeNew]: 'Новый эксперимент',
    [ROUTES.tasks.oneTime]: 'Единоразовые',
    [ROUTES.tasks.recurringNew]: 'Новое расписание',
    [ROUTES.tasks.recurring]: 'Регулярные',
  };
  if (path.startsWith(`${ROUTES.analytics.wordstat}/`)) return 'Отчёт Wordstat';
  if (exact[path]) return exact[path];
  if (path.startsWith(`${ROUTES.tasks.wordstat}/`)) return 'Задание Wordstat';
  if (path.startsWith(`${ROUTES.tasks.baskets}/`)) return 'Корзина запросов';
  if (path.startsWith(`${ROUTES.tasks.oneTime}/`)) return 'Эксперимент';
  if (path.startsWith(`${ROUTES.tasks.recurring}/`)) return 'Расписание';
  return 'Страница не найдена';
}

function normalizePath(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}
